import { createMapAction } from "chalet-shared";
import * as I from "immutable";

export const actionCreators = {
    doSortRoster: createMapAction(
        "DO_SORT_ROSTER",
        (x: { respectSortMoratorium: boolean; joinedRooms: I.Set<string> }) => x
    ),
};
